import React from "react";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import {
  Button,
  Menu,
  MenuItem,
  Fade,
  withStyles,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

const WEATHER_SOURCE_ID = "WeatherAlerts";

// Handle weather alert click popup doesn't open on marker click by checking if nodeName === "CANVAS", for markers it would be div or some part of svg
const onWeatherClicked =
  TrimbleMaps.WeatherAlertClickControl.prototype._onClick;
TrimbleMaps.WeatherAlertClickControl.prototype._onClick = function (event) {
  if (event.originalEvent.target.nodeName === "CANVAS") {
    onWeatherClicked.call(this, event);
  }
};
class MapView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      isTrafficVisible: false,
      isWeatherAlertVisible: false,
      isWeatherLegendVisible: false,
      isWeatherFilterVisible: false,
    };
    this.map = null;
    this.weatherLegendCtrl = null;
    this.weatherFilterCtrl = null;
    this.weatherAlertClickCtrl = null;
  }

  componentDidMount() {
    this.props.eventHub?.on(`set_${this.props.mapId}`, this.setMap);
  }

  componentWillUnmount() {
    this.props.eventHub?.off(`set_${this.props.mapId}`, this.setMap);
    this.map?.off("sourcedata", this.sourceLoaded);
  }

  setMap = (map) => {
    this.map = map;
    this.setState({
      isTrafficVisible: this.map.isTrafficVisible(),
      isWeatherAlertVisible: this.map.isWeatherAlertVisible(),
      isWeatherLayerLoaded: this.map.isWeatherAlertVisible(),
    });
    if (this.map.isWeatherAlertVisible()) {
      this.weatherAlertClickCtrl = new TrimbleMaps.WeatherAlertClickControl();
      this.map.addControl(this.weatherAlertClickCtrl);
    }
    this.map.on("sourcedata", this.sourceLoaded);
  };

  sourceLoaded = (source) => {
    // If weather layer is rendered and weather legend control is pending to display, display it now
    if (
      source.sourceId === WEATHER_SOURCE_ID &&
      source.isSourceLoaded &&
      this.state.isWeatherLegendVisible &&
      this.weatherLegendCtrl?._container?.style?.display === "none"
    ) {
      this.weatherLegendCtrl._refreshAlertList();
      this.weatherLegendCtrl._container.style.display = "block";
    }
  };

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  toggleTrafficVisibility = () => {
    const isTrafficVisible = !this.state.isTrafficVisible;
    this.map.setTrafficVisibility(isTrafficVisible);
    this.setState({
      isTrafficVisible,
    });
  };

  toggleWeatherVisibility = () => {
    const isWeatherAlertVisible = !this.state.isWeatherAlertVisible;
    if (isWeatherAlertVisible) {
      this.weatherAlertClickCtrl = new TrimbleMaps.WeatherAlertClickControl();
      this.map.addControl(this.weatherAlertClickCtrl);
    } else {
      this.setState({
        isWeatherLegendVisible: false,
        isWeatherFilterVisible: false,
        isWeatherLayerLoaded: false,
      });
      if (this.weatherAlertClickCtrl) {
        this.map.removeControl(this.weatherAlertClickCtrl);
        this.weatherAlertClickCtrl = null;
      }
      if (this.weatherLegendCtrl) {
        this.map.removeControl(this.weatherLegendCtrl);
        this.weatherLegendCtrl = null;
      }
      if (this.weatherFilterCtrl) {
        this.map.removeControl(this.weatherFilterCtrl);
        this.weatherFilterCtrl = null;
      }
    }
    this.map.setWeatherAlertVisibility(isWeatherAlertVisible);
    this.setState({
      isWeatherAlertVisible,
    });
  };

  toggleWeatherLegendVisibility = () => {
    const isWeatherLegendVisible = !this.state.isWeatherLegendVisible;
    if (isWeatherLegendVisible) {
      this.weatherLegendCtrl = new TrimbleMaps.WeatherAlertLegendControl();
      this.map.addControl(this.weatherLegendCtrl, "bottom-left");
      // If weather layer is not loaded, delay display of legend until it loaded, else weather layer is not getting rendered
      if (this.map.isSourceLoaded(WEATHER_SOURCE_ID)) {
        this.weatherLegendCtrl._refreshAlertList();
        this.weatherLegendCtrl._container.style.display = "block";
      }
    } else if (this.weatherLegendCtrl) {
      this.map.removeControl(this.weatherLegendCtrl);
      this.weatherLegendCtrl = null;
    }
    this.setState({
      isWeatherLegendVisible,
    });
  };

  toggleWeatherFilterVisibility = () => {
    const isWeatherFilterVisible = !this.state.isWeatherFilterVisible;
    if (isWeatherFilterVisible) {
      this.weatherFilterCtrl = new TrimbleMaps.WeatherAlertFilterControl();
      this.map.addControl(this.weatherFilterCtrl, "top-left");
      this.weatherFilterCtrl._container.style.display = "block";
    } else if (this.weatherFilterCtrl) {
      this.map.removeControl(this.weatherFilterCtrl);
      this.weatherFilterCtrl = null;
    }
    this.setState({
      isWeatherFilterVisible,
    });
  };

  removeMapControl = (control) => {
    if (control) {
      this.map.removeControl(control);
      // control = null;
    }
  };

  render() {
    if (!this.map) {
      return null;
    }
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { classes } = this.props;

    const {
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherLegendVisible,
      isWeatherFilterVisible,
    } = this.state;
    return (
      <div style={{ float: "left", marginTop: 2 }}>
        <Button
          aria-controls="fade-menu"
          aria-haspopup="true"
          className={classes.button}
          onClick={this.handleClick}
        >
          Map Views
          <ExpandMore className={classes.icon} />
        </Button>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Fade}
          elevation={1}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          MenuListProps={{
            classes: {
              root: classes.menuList,
            },
          }}
        >
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Traffic"
              checkboxProps={{
                name: "traffic",
                checked: isTrafficVisible,
                onChange: this.toggleTrafficVisibility,
              }}
            />
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Weather"
              checkboxProps={{
                name: "weather",
                checked: isWeatherAlertVisible,
                onChange: this.toggleWeatherVisibility,
              }}
            />
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Weather Legend"
              checkboxProps={{
                name: "weatherLegend",
                checked: isWeatherLegendVisible,
                disabled: !isWeatherAlertVisible,
                onChange: this.toggleWeatherLegendVisibility,
              }}
            />
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Weather Filter"
              checkboxProps={{
                disabled: !isWeatherAlertVisible,
                name: "weatherFilter",
                checked: isWeatherFilterVisible,
                onChange: this.toggleWeatherFilterVisibility,
              }}
            />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const checkBoxStyles = (theme) => ({
  checkBox: {
    padding: "2px 8px 2px 2px",
    color: theme.iconColor,
    "&$checkBoxDisabled": {
      color: theme.iconColor,
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  checkBoxDisabled: {},
  labelRoot: {
    margin: 0,
    flex: 1,
    padding: 6,
  },
  label: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    "&$disabledLabel": {
      color: theme.TextColor,
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  disabledLabel: {},
});

const LabeledCheckbox = withStyles(checkBoxStyles)(
  ({ classes, checkboxProps, ...labelProps }) => {
    return (
      <FormControlLabel
        classes={{
          label: classes.label,
          disabled: classes.disabledLabel,
          root: classes.labelRoot,
        }}
        {...labelProps}
        control={
          <Checkbox
            inputProps={{ "aria-label": labelProps.label }}
            color="primary"
            classes={{
              root: classes.checkBox,
              disabled: classes.checkBoxDisabled,
            }}
            {...checkboxProps}
          />
        }
      />
    );
  }
);

const styles = (theme) => ({
  button: {
    color: theme.TextColor,
    padding: "4px 8px",
    width: "100%",
    border: `1px solid ${theme.iconColor}`,
    fontSize: theme.textFontSize,
  },
  icon: {
    color: theme.iconColor,
    height: 16,
    width: 32,
  },
  menuItemRoot: {
    padding: 0,
    color: theme.TextColor,
    height: "auto",
  },
  menuList: {
    padding: 8,
    backgroundColor: theme.ModalBGColor,
  },
});

export default withStyles(styles)(MapView);
